import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { marketingMobileCuttoff } from '@css/constants'

export const LinkBlockWrapper = styled('div')(css`
  margin-top: 20px;

  @media(max-width: ${marketingMobileCuttoff}) {
    padding-left: 25px;
  }
`)

export const getLinkStyles = (color: string) => css`
  color: ${color};
`
